import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './static/footer/footer.component';
import { LoginComponent } from './view/login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LanguageSelectComponent } from './static/language-select/language-select.component';
import { HeaderComponent } from './static/header/header.component';
import { ListComponent } from './view/list/list.component';
import { TeaserComponent } from './shared/teaser/teaser.component';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { InlineSVGModule } from 'ng-inline-svg';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { OverviewComponent } from './view/overview/overview.component';
import { SliderTeaserComponent } from './shared/slider-teaser/slider-teaser.component';
import { HeadlineCenteredComponent } from './shared/headline-centered/headline-centered.component';
import { ToTopComponent } from './shared/to-top/to-top.component';
import { DetailComponent } from './view/detail/detail.component';
import { DetailSliderComponent } from './shared/detail-slider/detail-slider.component';
import { DetailDescriptionComponent } from './shared/detail-description/detail-description.component';
import { XcoScrolltoDirective } from './directives/xco-scrollto.directive';
import { XcoScrollToService } from './services/xco-scroll-to.service';
import { PullDownComponent } from './shared/pull-down/pull-down.component';
import { AutomobiliaComponent } from './view/automobilia/automobilia.component';
import { AutomobiliaTeaserComponent } from './shared/automobilia-teaser/automobilia-teaser.component';
import { ContactComponent } from './view/contact/contact.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ImprintComponent } from './view/imprint/imprint.component';
import { BodytextComponent } from './shared/bodytext/bodytext.component';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PropertyByNamePipe } from './pipes/property-by-name';
import { DatePipe, registerLocaleData } from '@angular/common';
import { ApiService } from './services/api.service';
import { AuthService } from './services/auth.service';
import { AuthGuard } from './services/auth-guard.service';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { SpeedometerLoaderComponent } from './shared/speedometer-loader/speedometer-loader.component';
import { AuthImagePipe } from './pipes/auth-image.pipe';
import { DealerManagementComponent } from './view/dealer-management/dealer-management.component';
import { AutomobiliaManagementComponent } from './view/automobilia-management/automobilia-management.component';
import { PropertyValuePipe } from './pipes/property-value';
import { AutomobiliaService } from './services/automobilia.service';
import { DealerService } from './services/dealer.service';
import { AutomobiliaSaleStatusFilterPipe } from './pipes/automobilia-sale-status-filter.pipe';
import { ForgotPasswordComponent } from './view/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './view/reset-password/reset-password.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { SearchComponent } from './shared/search/search.component';
import { SearchService } from './services/search.service';
import { ItemService } from './services/item.service';
import { NgxCurrencyModule } from 'ngx-currency';
import localeDe from '@angular/common/locales/de';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import {CarsWantedComponent} from './view/cars-wanted/cars-wanted.component';
import {CarsWantedManagementComponent} from './view/cars-wanted-management/cars-wanted-management.component';
import {WantedItemService} from './services/wanted-item.service';
import {TermsOfServiceComponent} from './view/terms-of-service/terms-of-service.component';
import {CarsWantedTeaserComponent} from './shared/cars-wanted-teaser/cars-wanted-teaser.component';
import {WantedItemStatusFilterPipe} from './pipes/wanted-item-status-filter.pipe';
import {PrivacyComponent} from './view/privacy/privacy.component';
registerLocaleData(localeDe);

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    LoginComponent,
    LanguageSelectComponent,
    HeaderComponent,
    ListComponent,
    TeaserComponent,
    OverviewComponent,
    SliderTeaserComponent,
    HeadlineCenteredComponent,
    ToTopComponent,
    DetailComponent,
    DetailSliderComponent,
    DetailDescriptionComponent,
    XcoScrolltoDirective,
    PullDownComponent,
    AutomobiliaComponent,
    AutomobiliaTeaserComponent,
    ContactComponent,
    ImprintComponent,
    TermsOfServiceComponent,
    PrivacyComponent,
    BodytextComponent,
    PropertyByNamePipe,
    PropertyValuePipe,
    SpeedometerLoaderComponent,
    AuthImagePipe,
    DealerManagementComponent,
    AutomobiliaManagementComponent,
    CarsWantedManagementComponent,
    AutomobiliaSaleStatusFilterPipe,
    WantedItemStatusFilterPipe,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    SearchComponent,
    CarsWantedComponent,
    CarsWantedTeaserComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    InlineSVGModule.forRoot({ baseUrl: '/assets/svg/' }),
    SwiperModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    NgHttpLoaderModule.forRoot(),
    NgxPaginationModule,
    NgxCurrencyModule,
    NgxSmartModalModule.forRoot(),
    ReactiveFormsModule
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'de-DE'},
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    XcoScrollToService,
    ApiService,
    AuthService,
    AuthGuard,
    DatePipe,
    PropertyByNamePipe,
    PropertyValuePipe,
    AutomobiliaService,
    DealerService,
    SearchService,
    ItemService,
    WantedItemService
  ],
  bootstrap: [AppComponent],
  entryComponents: [SpeedometerLoaderComponent]
})
export class AppModule {}
